import { observer } from 'mobx-react-lite'
import type { SubmissionViewModel } from '@/features/jobs/drafting/SubmissionViewModel'
import { type DraftJobViewModel } from '@/features/jobs/drafting/DraftJobViewModel'
import { StepContainer } from '@/features/jobs/drafting/components/JobCreation/JobCreationFormView/Step/StepContainer'
import { BillingContainer } from '@/features/jobs/drafting/components/JobCreation/Submission/Billing/BillingContainer'
import { PricingContainer } from '@/features/jobs/drafting/components/JobCreation/Submission/Pricing/PricingContainer'
import { CouponSelectionContainer } from '@/features/jobs/drafting/components/JobCreation/Submission/CouponSelection/CouponSelectionContainer'
import { JobCreationBilling } from '@/features/jobs/drafting/components/CreateJobDialog/JobCreationBilling'

export interface JobCreationBillingContainerProps {
  vm: DraftJobViewModel
}

export const JobCreationBillingContainer = observer(
  function JobCreationBillingContainer({
    vm,
  }: JobCreationBillingContainerProps) {
    return (
      vm.isSubmissionAvailable && (
        <BillingAndSummaryContainer vm={vm.submission} />
      )
    )
  },
)

interface BillingAndSummaryContainerProps {
  vm: SubmissionViewModel
}

const BillingAndSummaryContainer = observer(
  function BillingAndSummaryContainer({ vm }: BillingAndSummaryContainerProps) {
    const testId = 'draft-editor'
    const billingSection = vm.billing.shouldCollectPaymentInfo ? (
      <BillingContainer vm={vm.billing} compact testId={testId} />
    ) : null

    const couponSection = vm.billing.canUseCoupons && (
      <CouponSelectionContainer
        vm={vm.billing.couponSelection}
        compact
        testId={testId}
      />
    )

    return (
      <JobCreationBilling isLoading={vm.isLoading} testId={testId}>
        <StepContainer
          key={vm.step.stepId}
          stepAccessor={vm}
          isUntitled
          compact
        >
          {billingSection}
          {couponSection}
          <PricingContainer boxed vm={vm} compact />
        </StepContainer>
      </JobCreationBilling>
    )
  },
)
